export const RAY_MIN_DIST = 6;



/** WEBPACK FOOTER **
 ** ./src/game/constants.ts
 **/